export class PriorityDTO {
	constructor(
		public id?: number,
		public value?: string,
		public color: string = '#6985e0',
		public description?: string
	) {}
}
